export const TEST_IDS = {
  startDeal: {
    lead: {
      businessName: 'lead-business-name',
      contact: 'lead-contact',
      title: 'lead-title',
      email: 'lead-email',
      phone: 'lead-phone',
    },
    equipment: {
      quantity: 'equipment-quantity',
      year: 'equipment-year',
      make: 'equipment-make',
      model: 'equipment-model',
      class: 'equipment-class',
      serialNumberVin: 'equipment-serial-number-vin',
      stockId: 'equipment-stock-id',
      condition: 'equipment-condition',
      mileage: 'equipment-mileage',
      description: 'equipment-description',
      wholesaleCost: 'equipment-wholesale-cost',
      retailPrice: 'equipment-retail-price',
      actions: {
        searchInventory: 'equipment-search-inventory-btn',
        uploadImages: 'equipment-upload-images-btn',
        previewImages: 'equipment-preview-images-btn',
      },
    },
  },
} as const;
